import apiClient from '../lib/apiClient';

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      query.set(key, String(value));
    }
  });
  return query.toString() ? `?${query.toString()}` : '';
};

const logError = ({ status, response, url, error }) => {
  console.error('[googleFontsService] Falha ao carregar fontes', {
    status,
    response,
    url,
    error: error?.message || null,
  });
};

const googleFontsService = {
  async list(params = {}) {
    const suffix = buildQuery(params);
    const url = `/google-fonts${suffix}`;

    try {
      const { response, data } = await apiClient.request(url, { auth: false, meta: true });

      if (!response?.ok || !data?.success) {
        logError({ status: response?.status, response: data, url });
        return {
          success: false,
          message: 'Não foi possível carregar fontes',
          fonts: [],
          pagination: { page: 1, per_page: 0, total: 0, has_more: false },
        };
      }

      const fonts = Array.isArray(data.fonts) ? data.fonts : [];
      return {
        success: true,
        fonts,
        pagination: {
          page: 1,
          per_page: fonts.length,
          total: fonts.length,
          has_more: false,
        },
      };
    } catch (error) {
      logError({ status: null, response: null, url, error });
      return {
        success: false,
        message: 'Não foi possível carregar fontes',
        fonts: [],
        pagination: { page: 1, per_page: 0, total: 0, has_more: false },
      };
    }
  },

  async search(queryText, params = {}) {
    return this.list({ ...params, q: queryText || '' });
  },
};

export default googleFontsService;
